<template>
    <div>
        <v-card flat>
            <v-card-title>
                <span class="text-h5">{{ title }}</span>
                <v-btn icon href="https://files.gestionuniformes.cl/unf/UpdatePriceProducts.xlsx" target="_blank">
                    <v-icon color="green">mdi-microsoft-excel</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" md="8">
                            <v-file-input v-model="currentFile" label="Seleccionar archivo Excel (.xlsx, .xls)"
                                accept=".xlsx, .xls" placeholder="Haz clic para buscar el archivo"
                                prepend-icon="mdi-microsoft-excel" outlined dense @change="resetData"></v-file-input>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-btn color="success" class="white--text" :disabled="!currentFile" @click="readExcelFile"
                                block>
                                Procesar Archivo
                            </v-btn>
                        </v-col>
                    </v-row>

                    <div v-if="excelData.length > 0">
                        <v-divider class="my-3"></v-divider>
                        <p class="subtitle-1">Vista previa de datos ({{ excelData.length }} filas):</p>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                            hide-details></v-text-field>
                        <v-data-table :headers="headers" :items="excelData" :items-per-page="5" :search="search"
                            class="elevation-1 custom-font">
                            <template v-slot:item.flag="{ item }">
                                <v-icon :color="item.flag ? 'green' : 'red'">
                                    {{ item.flag ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                                </v-icon>
                            </template>
                        </v-data-table>
                    </div>

                    <div v-else-if="loading" class="text-center py-5">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        <p>Leyendo archivo...</p>
                    </div>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-alert shaped dense dark type="error" v-if="error">
                    Se han detectado filas con errores
                </v-alert>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cancelAction">
                    Cancelar
                </v-btn>
                <v-btn color="blue darken-1" text @click="confirmData"
                    v-if="excelData.length > 0 && this.error === false">
                    Cargar Inventario
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import * as XLSX from 'xlsx';
import { headersUpdatePrices } from "../commons/headers";
import { updateProduct } from "../dataApi";
export default {
    name: 'UpdatePrices',
    props: {
        title: {
            type: String,
            default: 'Actualizar Precios'
        },
        products: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        currentFile: null,
        excelData: [],
        headers: headersUpdatePrices,
        loading: false,
        error: false,
        search: ''
    }),
    mounted() {
        console.log(this.products);
    },
    methods: {
        // Limpia la tabla si el usuario cambia el archivo
        resetData() {
            this.excelData = [];
        },

        cancelAction() {
            this.$emit("cancelStock");
            this.currentFile = null;
            this.resetData();
        },

        confirmData() {
            this.excelData.forEach(async (product) => {
                delete product.flag;
                delete product.product;
                await updateProduct(product);
            });
            this.$emit('executeUpdatePrices', this.excelData);
        },

        readExcelFile() {
            if (!this.currentFile) return;

            this.loading = true;
            const reader = new FileReader();

            reader.onload = (e) => {
                try {
                    const data = e.target.result;

                    // 1. Leer el libro
                    const workbook = XLSX.read(data, { type: 'array' });

                    // 2. Tomar la primera hoja
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];

                    // 3. Convertir a JSON
                    const jsonData = XLSX.utils.sheet_to_json(worksheet);

                    console.log("🚀 Datos leídos del Excel:", jsonData);

                    if (jsonData.length > 0) {
                        const processedData = jsonData.map(excelRow => {
                            const row = this.processRow(excelRow);
                            row.id = this.products.find(p => p.name == excelRow.product)?.id || null;
                            return row;
                        });

                        this.excelData = processedData;
                    } else {
                        console.warn("El archivo Excel está vacío o no se pudo leer correctamente.");
                    }

                } catch (error) {
                    console.error("Error al leer el archivo Excel:", error);
                } finally {
                    this.loading = false;
                }
            };

            reader.readAsArrayBuffer(this.currentFile);
        },

        processRow(excelRow) {
            let flag = true;
            const newRow = {};

            this.headers.forEach(header => {
                const fieldKey = header.value;
                let value = excelRow[fieldKey];

                if (typeof value === 'string') {
                    value = value.trim().toUpperCase();
                }

                switch (fieldKey) {
                    case 'product':
                        value = this.products.find(p => p.name == excelRow.product)?.description || null;
                        break;
                    case 'flag':
                        break;
                    default:
                        if (value === null || value === undefined || value === '') {
                            console.log("🚀 ~ processRow ~ value:", fieldKey, value);
                            flag = false;
                        }
                }
                newRow[fieldKey] = value;
            });
            newRow['flag'] = flag;
            if (!flag) this.error = true;
            return newRow;
        },
    }
}
</script>

<style scoped>
.custom-font {
    font-size: 0.9rem;
}
</style>